import { useState } from "react";
import { Lock, Check } from "lucide-react";
import { REDEEM_ITEMS, CATEGORY_LABELS } from "@/lib/sparks";

const TABS = [
  { id: "all",         label: "Todo" },
  { id: "promotion",   label: "Promoción" },
  { id: "profile",     label: "Personalización" },
  { id: "marketplace", label: "Marketplace" },
];

export default function RedemptionCatalog({ balance, onRedeem }) {
  const [tab, setTab] = useState("all");
  const items = tab === "all" ? REDEEM_ITEMS : REDEEM_ITEMS.filter((i) => i.category === tab);
  const total = balance?.total_sparks ?? 0;

  return (
    <section data-testid="redemption-catalog" className="border hairline bg-cream-card rounded-2xl p-6 md:p-8">
      <div className="flex flex-wrap items-end justify-between gap-3 mb-5">
        <div>
          <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-coral">recompensas Spark</p>
          <h3 className="font-serif text-3xl tracking-tight mt-1">Canjea lo que has ganado</h3>
          <p className="text-sm text-ink-mid mt-1">{CATEGORY_LABELS.promotion} · {CATEGORY_LABELS.profile} · {CATEGORY_LABELS.marketplace}</p>
        </div>
        <div className="flex flex-wrap gap-1 bg-cream rounded-full p-1 border hairline">
          {TABS.map((t) => (
            <button
              key={t.id}
              data-testid={`redeem-tab-${t.id}`}
              onClick={() => setTab(t.id)}
              className={`px-3.5 py-1.5 rounded-full text-xs transition ${
                tab === t.id ? "bg-ink text-cream" : "text-ink-mid hover:text-ink"
              }`}
            >
              {t.label}
            </button>
          ))}
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3">
        {items.map((it) => {
          const Icon = it.icon;
          const canAfford = total >= it.cost;
          return (
            <div
              key={it.id}
              data-testid={`redeem-${it.id}`}
              className={`relative border rounded-2xl p-5 transition ${
                canAfford ? "border-ink/15 bg-cream-card hover:border-coral hover:shadow-lg" : "border-ink/10 bg-cream/40"
              }`}
            >
              <div className="flex items-center gap-2 mb-3">
                <span className={`w-9 h-9 rounded-xl flex items-center justify-center ${canAfford ? "bg-coral/10 text-coral" : "bg-ink/5 text-ink-mid"}`}>
                  <Icon className="w-4 h-4" strokeWidth={1.8} />
                </span>
                <span className={`font-mono text-[10px] uppercase tracking-[0.25em] ${canAfford ? "text-coral" : "text-ink-mid"}`}>
                  {CATEGORY_LABELS[it.category]}
                </span>
              </div>
              <h4 className="font-serif text-xl leading-tight mb-1">{it.label}</h4>
              <p className="text-[12.5px] text-ink-mid leading-relaxed mb-5">{it.desc}</p>
              <div className="flex items-center justify-between gap-3 pt-3 border-t hairline">
                <span className="text-sm font-mono text-coral">{it.cost.toLocaleString("es")} ✦</span>
                <button
                  data-testid={`redeem-btn-${it.id}`}
                  onClick={() => onRedeem(it.id)}
                  disabled={!canAfford}
                  className={`inline-flex items-center gap-1.5 text-xs px-4 py-2 rounded-full transition ${
                    canAfford
                      ? "bg-ink text-cream hover:bg-coral"
                      : "bg-cream-deep text-ink-mid cursor-not-allowed"
                  }`}
                >
                  {canAfford ? <><Check className="w-3 h-3" /> Canjear</> : <><Lock className="w-3 h-3" /> Bloqueado</>}
                </button>
              </div>
              {!canAfford && (
                <p className="mt-2 text-[10px] font-mono uppercase tracking-wider text-ink-mid">
                  faltan {(it.cost - total).toLocaleString("es")} ✦
                </p>
              )}
            </div>
          );
        })}
      </div>
    </section>
  );
}
